import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SplitType from 'split-type';
import lazyVideos from '../../../resources/scripts/utils/lazyVideos';

gsap.registerPlugin(ScrollTrigger);

export function getDynamicWidth(contentBlocks) {
  let totalWidth = 0;

  contentBlocks.forEach((block) => {
    totalWidth += block.getBoundingClientRect().width;
  });

  return totalWidth;
}

export function initProjectScroll() {
  let isPreloaderDone = false;
  document.addEventListener('preloaderDone', () => {
    isPreloaderDone = true;
  });

  function textAnimations(project, animation) {
    const spitText = project.querySelector('[data-split-text]');
    const parallax = project.querySelector('[data-project-parallax]');

    if (spitText) {
      // eslint-disable-next-line no-new
      new SplitType(spitText);

      if (isPreloaderDone || sessionStorage.getItem('preloaderDone')) {
        gsap.to(spitText.querySelectorAll('.char'), {
          opacity: 1,
          y: 0,
          stagger: 0.05,
          delay: 0.2,
          duration: 0.1,
        });
      } else {
        gsap.set(spitText.querySelectorAll('.char'), { opacity: 0 });
        document.addEventListener('preloaderDone', () => {
          gsap.to(spitText.querySelectorAll('.char'), {
            opacity: 1,
            y: 0,
            stagger: 0.05,
            delay: 0.2,
            duration: 0.1,
          });
        });
      }
    }

    if (parallax) {
      gsap.to(parallax, {
        ease: 'none',
        scrollTrigger: {
          trigger: `#${project.id}`,
          containerAnimation: animation,
          start: 'left right',
          end: 'right left',
          scrub: true,
          invalidateOnRefresh: true,
        },
      });
    }
  }

  if (!document.body.classList.contains('home')) {
    lazyVideos();

    const sections = document.querySelectorAll('.project-scroll');
    const totalWidth = getDynamicWidth(sections);

    sections.forEach((section) => {
      const projectList = gsap.utils.toArray('.project-scroll__project', section);

      if (projectList.length > 1) {
        const scrollTween = gsap.to(projectList, {
          xPercent: -100 * (projectList.length - 1),
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            pin: true,
            scrub: 0.1,
            end: `+=${totalWidth}`,
          },
        });

        const projects = section.querySelectorAll('.project-scroll__project');

        const lastProject = projects[projects.length - 1];
        Object.entries(projects).slice(0, -1);
        projects.forEach((project) => {
          const projCard = gsap.utils.toArray(`#${project.id}`, section);

          gsap.to(projCard, {
            y: 0,
            duration: 2,
            ease: 'elastic',
            scrollTrigger: {
              trigger: `#${project.id}`,
              containerAnimation: scrollTween,
              start: 'left center',
              toggleActions: 'play none none reset',
              id: project.getAttribute('data-loop-index'),
            },
          });

          textAnimations(project, scrollTween);
        });

        ScrollTrigger.create({
          trigger: `#${lastProject.id}`,
          containerAnimation: scrollTween,
          toggleClass: 'active',
          start: 'center 60%',
          id: lastProject.getAttribute('data-loop-index'),
        });
      } else {
        const project = section.querySelector('.project-scroll__project');

        textAnimations(project, '');
      }
    });
  }
}
